var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.model.text,"error":!_vm.model.isValid,"dense":""},on:{"input":function($event){return _vm.updateValue($event)}},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }